<template>
    <FilterModal :filterable="__('general.category')"
                 :value="selectedCategory ?? __('statistics.all_categories')"
                 :filters-changed="filtersChanged"
                 @apply="$emit('input', selectedCategory)"
    >
        <div class="w-full">
            <!-- Option für Alle Kategorien -->
            <div class="mb-4">
                <div class="checkbox-inline">
                    <label for="all_categories" class="checkbox checkbox-primary text-xl font-semibold mb-0">
                        <input
                            hidden
                            type="radio"
                            id="all_categories"
                            v-model="selectedCategory"
                            :value="null"
                            class="mr-2"/>
                        <span></span> {{ __('statistics.all_categories') }}
                    </label>
                </div>
            </div>

            <!-- Bestehende Kategorien -->
            <div
                v-for="(categoriesL2, categoryL1) in selectableCategories"
                :key="categoryL1"
                class="mb-4">
                <!-- Main categories (Level 1) -->
                <div @click="toggleCategoryL1(categoryL1, categoriesL2)" class="cursor-pointer">
                    <div class="checkbox-inline">
                        <label :for="categoryL1" :class="['checkbox checkbox-primary text-xl font-semibold mb-0', selectedCategory === categoryL1 ? 'text-primary': '']">
                            <input
                                hidden
                                type="radio"
                                :id="categoryL1"
                                v-model="selectedCategory"
                                :value="categoryL1"
                                class="mr-2"/>
                            <span></span> {{ categoryL1 }}
                            <i v-if="categoriesL2.length !== 0 && !onlyL1Categories" :class="['text-lg fas fa-angle-right ml-2', isCategoryExpanded(categoryL1) ? 'rotate-90' : 'rotate-0']"></i>
                        </label>
                    </div>
                </div>

                <!-- Subcategories (Level 2) -->
                <div v-if="isCategoryExpanded(categoryL1) && !onlyL1Categories" class="pl-6 my-3">
                    <div
                        v-for="categoryL2 in categoriesL2"
                        :key="categoryL2"
                        class="d-flex align-items-center cursor-pointer my-2">
                        <div class="checkbox-inline">
                            <label :for="categoryL2" :class="['checkbox checkbox-primary text-lg font-semibold cursor-pointer mb-0', selectedCategory === categoryL2 ? 'text-primary': '']">
                                <input
                                    type="radio"
                                    :id="categoryL2"
                                    v-model="selectedCategory"
                                    :value="categoryL2"
                                    class="mr-2"/>
                                <span></span> {{ categoryL2 }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </FilterModal>
</template>

<script>
import FilterModal from '@components/Stats/FilterModal.vue';

export default {
    components: { FilterModal },

    props: {
        value: [String, null],
        selectableCategories: Object,
        onlyL1Categories: Boolean,
    },

    data() {
        return {
            selectedCategory: this.value,
            expandedCategory: null,
        };
    },

    computed: {
        filtersChanged() {
            return this.value !== this.selectedCategory;
        },
    },

    methods: {
        toggleCategoryL1(categoryL1, categoriesL2) {
            if (this.expandedCategory === categoryL1 && categoriesL2 && categoriesL2.length !== 0) {
                this.expandedCategory = null;
            } else {
                this.expandedCategory = categoryL1;
            }
        },

        isCategoryExpanded(categoryL1) {
            return this.expandedCategory === categoryL1;
        },
    },
};
</script>

